import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import _ from 'lodash'
import moment from 'moment'
import { saveAs } from 'file-saver'

import { Roles } from '../../config'

import { Table, Button } from 'antd'

const notVisibleExtraFields = ['assignee', 'assigneeName', 'company', 'appointmentDate', 'reachedType']

class AppointmentsTable extends Component {
  state = {
    selectedRows: []
  }

  expandedRowRender = record => {
    const { t, match: { params }, projects } = this.props

    const currentProject = projects[params.projectId]
    // get Project Questions - so we can use the question texts instead of IDs
    const projectQuestions = currentProject.questions

    return (
      <table>
        <tbody>
          {_.map(
            record.data,
            // 'key' = input name, 'value' = input value
            (value, key) =>
              value !== null &&
              !notVisibleExtraFields.includes(key) &&
              <tr key={key} style={{ padding: key === 'questions' ? '10px 0' : 0 }}>
                <td style={{ width: 120, verticalAlign: 'top' }}>
                  <b>{t(`contactLog.${key}`)}</b>
                </td>
                <td style={{ verticalAlign: 'top' }}>
                  {key === 'questions' // go through all answers and render them
                    ? _.map(value, (answer, questionId) => (
                      <div style={{ paddingBottom: 5 }} key={questionId}>
                        <div style={{ fontWeight: 'bold' }}>
                            •{' '}
                          {/* if someone deletes some question after we already did some calls, use question.id instead of question.text */}
                          {projectQuestions[questionId] ? projectQuestions[questionId].text : questionId}
                        </div>
                        <div>{answer}</div>
                      </div>
                      ))
                    : key === 'assignee'
                        ? value === 'generic' ? record.data.assigneeName : undefined
                        : typeof value === 'boolean' ? value === true ? 'true' : 'false' : value}

                </td>
              </tr>
          )}
        </tbody>
      </table>
    )
  }

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => this.setState({ selectedRows })
  }

  exportIcs = () => {
    const ics = require('ics-browser')
    const { selectedRows } = this.state

    const eventsArray = []

    selectedRows.forEach(appointment => {
      const dateTime = new Date(appointment.data.appointmentDate)

      eventsArray.push({
        title: `${appointment.company} meeting`,
        start: [
          dateTime.getUTCFullYear(),
          dateTime.getMonth() + 1,
          dateTime.getDate(), // returns 'day'; getDay() would return day of week
          dateTime.getHours(),
          dateTime.getMinutes()
        ],
        duration: { hours: 1 }
      })
    })

    ics.createEvents(eventsArray, (error, value) => {
      if (!error) {
        saveAs(new Blob([value], { type: 'application/octet-stream' }), 'appointments.ics')
      } else {
        console.log(error)
      }
    })
  }

  render () {
    const { t, role, match: { params }, contacts, appointments, projects, companies } = this.props
    const { selectedRows } = this.state

    const currentProject = projects[params.projectId]

    // get Company Users - so we can use their names (users[userId]: { name_sync }) instead of IDs
    const companyUsers = companies[currentProject.companyId].users

    // table columns visible for all
    const columns = [
      {
        title: t('contactLog.company'),
        dataIndex: 'company'
      },
      {
        title: t('contactLog.appointmentDate'),
        dataIndex: 'appointmentDate'
      }
    ]

    // add 'salesPerson' column to roles other than salesperson
    if (role !== Roles.PROJECT.SALESPERSON) {
      columns.unshift({
        title: t('contactLog.assignee'),
        dataIndex: 'assignee'
      })
    }

    let tableData = []
    _.orderBy(appointments, 'appointmentDate', 'asc').forEach((appointment, index) => {
      const currentContact = contacts && contacts[appointment.contactId]

      tableData.push({
        key: index,
        assignee: appointment.data.assignee === 'generic'
          ? appointment.data.assigneeName
          : companyUsers[appointment.data.assignee].name_sync,
        company: (currentContact && currentContact.company) || appointment.contactId,
        appointmentDate: moment(parseInt(appointment.data.appointmentDate, 10)).format('MMMM Do YYYY, HH:mm'),
        data: appointment.data
      })
    })

    return (
      <div>

        <Table
          columns={columns}
          dataSource={tableData}
          expandedRowRender={this.expandedRowRender}
          rowSelection={this.rowSelection}
          size='small'
          pagination={false}
        />

        {selectedRows.length > 0 &&
          <Button onClick={() => this.exportIcs()} style={{ marginTop: 30 }}>
            Export as ICS
          </Button>}

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user,
  contacts: state.contacts,
  appointments: state.appointments,
  projects: state.projects,
  companies: state.companies
})

export default connect(mapStateToProps)(withRouter(translate('translations')(AppointmentsTable)))



// WEBPACK FOOTER //
// ./src/components/Appointments/AppointmentsTable.js